import { useLang } from '@/i18n';
import css from './index.module.scss';
import { ItfCard, ItfItem } from './type';
import { useState, useEffect } from 'react';
import EcoPicture from 'eco-design/base/eco-picture';

const G: React.FC = () => {
    const { t } = useLang('ces2026.G');
    const [enter, setEnter] = useState(false);
    const items: ItfItem[] = [
        {
            text: t('item1_text'),
            suffix: 'M+',
            arr: [1, 2, 3, 4, 5],
        },
        {
            text: t('item2_text'),
            suffix: '+',
            arr: [20, 40, 60, 80, 100, 120, 140],
        },
        {
            text: t('item3_text'),
            suffix: '',
            arr: [200, 400, 600, 800, '1,000', '1,129'],
        },
        {
            text: t('item4_text'),
            suffix: '+',
            arr: [10, 20, 30, 40, 50, 60],
        },
    ];

    const cards: ItfCard[] = [
        {
            text: t('card1_text'),
            logo: 'https://websiteoss.ecoflow.com/upload/image/1766054442483/1_best.png',
        },
        {
            text: t('card2_text'),
            logo: 'https://websiteoss.ecoflow.com/upload/image/1766054442646/2_if.png',
        },
        {
            text: t('card3_text'),
            logo: 'https://websiteoss.ecoflow.com/upload/image/1766054442860/3_ces.png',
        },
        {
            text: t('card4_text'),
            logo: 'https://websiteoss.ecoflow.com/upload/image/1766054443136/4_reddot.png',
        },
        {
            text: t('card5_text'),
            logo: 'https://websiteoss.ecoflow.com/upload/image/1766054443366/5_ux.png',
        },
        {
            text: t('card6_text'),
            logo: 'https://websiteoss.ecoflow.com/upload/image/1766054443415/6_yd.png',
        },
        {
            text: t('card7_text'),
            logo: 'https://websiteoss.ecoflow.com/upload/image/1766054443797/7_tech.png',
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const scenes: any[] = [];
            ['items']?.map((cls: string) => {
                scenes?.push(
                    AniContainer.create({
                        triggerElement: `.${css.section} .${cls}`,
                        triggerHook: 1,
                        offset: 160,
                        duration: '100%',
                        onEnter: () => setEnter(true),
                        onLeave: () => setEnter(false),
                    }),
                );
            });
            // const el: HTMLDivElement | null = document.querySelector('.ces-2026-F');
            // if (el) {
            //     scenes.push(
            //         AniContainer.create({
            //             triggerElement: el,
            //             triggerHook: 1,
            //             offset: (el.offsetHeight + window.innerHeight) / 2,
            //             duration: '50%',
            //             syncFromTo: [
            //                 ['.ces-2026-G', { y: window.innerHeight / 2 }, { y: 0 }],
            //                 ['.ces-2026-F .box-inner', { opacity: 1 }, { opacity: 0 }],
            //             ],
            //         }),
            //     );
            // }
            return () => scenes?.forEach((scene: any) => scene && scene?.destroy());
        }
    }, []);

    return (
        <div id="ces-2026-G" className={`ces-2026-G ${css.section} GtmModuleData-section`} data-section-id={'ces-2026-G'}>
            <div className="box1">
                <div className="img">
                    <EcoPicture
                        jpg={[
                            'https://websiteoss.ecoflow.com/upload/image/1766110091474/G.jpg',
                            'https://websiteoss.ecoflow.com/upload/image/1766110092460/G_pad.jpg',
                            'https://websiteoss.ecoflow.com/upload/image/1766110092746/G_m.jpg',
                        ]}
                        webp={[
                            'https://websiteoss.ecoflow.com/upload/image/1766110091749/G.webp',
                            'https://websiteoss.ecoflow.com/upload/image/1766110091187/G_pad.webp',
                            'https://websiteoss.ecoflow.com/upload/image/1766110092129/G_m.webp',
                        ]}
                        alt={t('title')}
                    />
                </div>
                <div className="info">
                    <h2 className="title-big">{t('title')}</h2>
                </div>
                <div className="content">
                    <div className="name-box">
                        <h2 className="super-title">{'No.1'}</h2>
                        <h2 className="title">
                            {t.rich('name', {
                                sup: (tx: string) => <sup>{tx}</sup>,
                            })}
                        </h2>
                    </div>
                    <ul className="items">
                        {items?.map((item: ItfItem, i: number) => (
                            <li className="item" key={i}>
                                <div className={`item-title ${enter ? 'enter' : 'leave'}`}>
                                    <ul className="item-nums" style={{ '--n': item.arr?.length } as React.CSSProperties}>
                                        {item.arr?.map((n: number | string, j: number) => (
                                            <li className="item-num" key={`${i}-${j}`}>
                                                {n}
                                            </li>
                                        ))}
                                    </ul>
                                    <span className="item-suffix">{item.suffix}</span>
                                </div>
                                <p className="item-text">{item.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="box2">
                <ul className="cards">
                    {[...cards, ...cards]?.map((card: ItfCard, i: number) => (
                        <li className="card" key={i}>
                            <div className="card-img">
                                <EcoPicture jpg={[card.logo]} />
                            </div>
                            <p className="card-text text">{card.text}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default G;
